export const PDF_SCALES = {
  AUTO: 'auto',
  PAGE_WIDTH: 'page-width',
  PAGE_HEIGHT: 'page-height',
  PAGE_ACTUAL: 'page-actual',
  FIT_PAGE: 'fit-page',
};
